const agreement_confirmsend_reducer = (state = false, action) => {
	switch(action.type) {

		case 'UPDATEAGREEMENTCONFIRMSEND':
			return typeof action.payload !== "undefined" ? action.payload : false;

		default:
			return state;
	}
}

export default agreement_confirmsend_reducer;
